// @ts-nocheck

/**
 * Determine if we have to consider to decimal part of the number
 *
 * @param  {number}  number The number
 * @return {boolean}        The answer
 */
const isRealFloat = (number) => {
  // We must round the value in order to resolve the epsilon problem
  // i.e. : 0.1 + 0.7 -> 0.7999999999999999
  const floatValue = Math.round(number * 100) / 100;
  // eslint-disable-next-line no-bitwise
  const intValue = floatValue >> 0;
  return intValue !== floatValue;
};

const factorial = (number) => {
  if (number > 1) return number * factorial(number - 1);
  return 1;
};

// Nombre de combinations de k parmi un ensemble n
const getNbCombinations = (k, n) => Math.round(factorial(n) / (factorial(k) * factorial(n - k)));

/* retourne toutes combinaisons de {k} elements dans l'ensemble {set} */
const getCombinationsInner = (start, choose, arr, n, result, combination) => {
  if (choose === 0) {
    result.push(combination.concat());
  } else {
    for (let i = start; i <= n - choose; ++i) {
      combination.push(arr[i]);
      getCombinationsInner(i + 1, choose - 1, arr, n, result, combination);
      combination.pop();
    }
  }
};

const getCombinations = (arr, choose) => {
  const n = arr.length;
  const result = [];
  const combination = [];
  getCombinationsInner(0, choose, arr, n, result, combination);
  return result;
};

const castNumber = (value) => +value;

const roundDownwardCents = (value) => {
  const str = value.toString();
  if (!str || !str.length) {
    return 0;
  }
  if (str.indexOf('.') >= 0) {
    const arr = str.split('.');
    while (arr[1].length < 3) {
      arr[1] += '0';
    }
    arr[1] = arr[1].substr(0, 3);
    const valueInCents = parseInt(arr[0] + arr[1]);
    return Math.round((valueInCents - 1) / 10) / 100;
  } else {
    return value;
  }
};

export const normalize = (value, min, max, minDestination, maxDestination) => {
  return minDestination + ((value - min) * (maxDestination - minDestination)) / (max - min);
};

// check if a value equals to NaN
// use of Number.isNaN() for the browsers which support it
// use of isNaN() for old browsers
// @see compatibility here https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
const checkIsNaN = (value) => {
  return Number.isNaN(value) || (typeof value === 'number' && isNaN(value));
};

export const easeInOutCubic = (x: number): number => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);

export const lerp = (a, b, t) => (1 - t) * a + t * b;

export const getNumberOfDecimals = (str) => {
  if (typeof str !== 'string') {
    return 0;
  }
  const comaIndex = str.indexOf('.');

  if (comaIndex !== -1) {
    return str.length - comaIndex - 1;
  }
  return 0;
};

export default {
  castNumber,
  factorial,
  getCombinations,
  getNbCombinations,
  checkIsNaN,
  isRealFloat,
  normalize,
  roundDownwardCents,
};
